/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'
import PropTypes from 'prop-types'
import styled, { space, color, display } from '@style'

/**
 * Update from
 * https://undraw.co
 */

function Icon({ size, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 1076.064 755.228" {...props}>
      <path
        d="M864.146 702.423c-6.985 26.598-31.46 43.22-31.46 43.22s-13.15-26.502-6.165-53.1 31.459-43.22 31.459-43.22 13.15 26.502 6.166 53.1z"
        fill="#3f3d56"
      />
      <path
        d="M853.552 696.797c-19.563 19.327-21.751 48.83-21.751 48.83s29.528-1.83 49.09-21.158 21.752-48.831 21.752-48.831-29.529 1.831-49.091 21.159z"
        fill="#6c63ff"
      />
      <path
        d="M144.734 601.808h36.841l90.788-35.525s64.473-26.316 59.21 23.683-14.474 117.103-14.474 117.103-28.947-13.157-44.736-9.21-5.263-80.262-5.263-80.262-128.945 61.841-140.787 53.947-14.473-63.157-14.473-63.157z"
        fill="#2f2e41"
      />
      <path
        d="M144.734 601.808h36.841l90.788-35.525s64.473-26.316 59.21 23.683-14.474 117.103-14.474 117.103-28.947-13.157-44.736-9.21-5.263-80.262-5.263-80.262-128.945 61.841-140.787 53.947-14.473-63.157-14.473-63.157z"
        opacity={0.1}
      />
      <path
        d="M202.778 486.434l44.586 64.06 103.945 86.84s96.05 22.368 82.893 38.157-93.42-15.79-93.42-15.79-119.734-86.84-123.68-93.418-47.368-68.42-47.368-68.42z"
        fill="#a0616a"
      />
      <path
        d="M202.778 486.434l44.586 64.06 103.945 86.84s96.05 22.368 82.893 38.157-93.42-15.79-93.42-15.79-119.734-86.84-123.68-93.418-47.368-68.42-47.368-68.42z"
        opacity={0.1}
      />
      <path
        d="M176.312 434.706l28.947 56.578s-6.579 27.631-17.105 30.263-55.262-34.21-55.262-34.21z"
        fill="#d0cde1"
      />
      <path
        d="M176.312 434.706l28.947 56.578s-6.579 27.631-17.105 30.263-55.262-34.21-55.262-34.21z"
        opacity={0.1}
      />
      <path
        d="M529.451 572.514l8.55 35.272a2.203 2.203 0 01-.042 1.19l-38.788 121.212a2.203 2.203 0 01-4.287-.423l-5.366-47.22a2.203 2.203 0 01.095-.93l35.602-109.264a2.203 2.203 0 014.236.163z"
        fill="#2f2e41"
      />
      <path
        fill="#f2f2f2"
        d="M526.306 575.493l7.894 30.263-34.21 110.524-7.894-34.21 34.21-106.577z"
      />
      <path
        d="M353.94 739.964c1.316 3.947 136.84-1.316 138.156-2.632a28.56 28.56 0 002.894-5.263 198.144 198.144 0 002.369-5.263l-5.263-42.605-134.208-4.763s-3.355 36.105-4.04 52.631c-.17 4.171-.17 7.105.093 7.895z"
        fill="#2f2e41"
      />
      <path
        opacity={0.1}
        d="M474.991 689.965l2.631 36.841h-59.209v-36.841h56.578zM398.677 701.806l.353-.07-1.669 15.86h-32.894v-15.79h34.21zM353.94 739.964c1.316 3.947 136.84-1.316 138.156-2.632a28.56 28.56 0 002.894-5.263H353.848c-.17 4.171-.17 7.105.093 7.895z"
      />
      <circle cx={196.049} cy={357.076} r={59.209} fill="#a0616a" />
      <path
        d="M192.102 409.707s-19.737 34.21-23.684 52.63-59.21-36.841-59.21-36.841l-7.236-19.079s51.972-24.341 48.025-44.078 42.105 47.368 42.105 47.368zM202.628 512.336l53.946 71.052 128.945 96.05s93.42 19.737 72.367 34.21-81.577-13.157-81.577-13.157-130.261-69.736-157.892-98.683-78.946-77.63-78.946-77.63z"
        fill="#a0616a"
      />
      <path
        d="M130.26 622.86l15.79 25 94.231-29.646c20.676-6.504 43.348-4.111 61.687 7.443 16.447 10.361 26.973 26.808 3.29 51.15-47.368 48.683-78.947 22.368-78.947 22.368S67.104 774.173 40.79 737.332 13.158 682.07 13.158 682.07s101.313-63.157 117.103-59.21z"
        fill="#2f2e41"
      />
      <path
        d="M327.625 709.701s42.105 27.631-7.894 40.789-86.84-5.263-86.84-5.263-43.42 0-43.42-22.368 14.472-25 14.472-25l44.736 6.579s53.947-14.473 78.946 5.263z"
        fill="#d0cde1"
      />
      <path
        d="M244.621 342.182c4.03 1.796 8.026 3.923 12.408 4.444s9.37-1.008 11.443-4.903c1.12-2.104 1.248-4.578 1.3-6.96.159-7.226-.364-15.037-4.942-20.628-2.914-3.559-7.168-5.802-10.184-9.274-2.161-2.488-3.6-5.503-5.148-8.412-5.866-11.017-14.551-21.605-26.622-24.781-5.04-1.327-10.328-1.262-15.54-1.188l-30.396.429c-4.92.069-9.914.15-14.623 1.573-9.784 2.959-16.908 11.186-23.433 19.055-4.88 5.886-9.775 11.834-13.438 18.546a65.079 65.079 0 00-7.714 31.887 29.833 29.833 0 001.092 8.438 46.822 46.822 0 003.317 7.284c5.7 11.196 9.085 25.182 2.665 35.982 11.152-4.555 22.186-10.528 29.542-20.067 3.291-4.268 5.872-9.264 10.258-12.395s11.532-3.403 14.346 1.193a12.857 12.857 0 011.45 6.022c.206 3.45.2 7.033 1.663 10.164s4.947 5.657 8.274 4.72c5.728-1.613 5.18-10.406 9.592-14.4 3.351-3.033 8.52-2.453 12.826-3.83 5.016-1.604 8.78-5.95 10.924-10.76 1.63-3.655 1.606-13.222 4.69-15.202 3.868-2.483 12.665 1.464 16.25 3.063z"
        fill="#2f2e41"
      />
      <path
        d="M97.272 400.176a15.616 15.616 0 018.128.02c8.446 2.268 27.38 8.271 31.44 17.405 5.263 11.842 23.683 30.263 23.683 30.263s25 25 19.737 42.104-25 36.842-25 36.842 5.263 81.577-21.052 102.63-36.841 6.578-36.841 26.315S15.789 737.332 0 699.175c0 0 7.895-71.051 5.263-96.05-2.594-24.64 1.203-178.366 92.009-202.949z"
        fill="#d0cde1"
      />
      <path
        d="M139.471 433.39s80.262 59.21 65.788 84.21c0 0-48.683 23.683-59.21 22.367S94.736 492.6 84.21 488.653s-15.79-74.999 55.262-55.263z"
        fill="#d0cde1"
      />
      <circle cx={498.064} cy={237.458} r={65} fill="#f2f2f2" />
      <path
        d="M1034.93 153.04H670.68V76.822h364.249zm-362.644-1.604h361.039v-73.01h-361.04z"
        fill="#3f3d56"
      />
      <path fill="#6c63ff" d="M645.809 92.065h362.644v74.615H645.809z" />
      <circle cx={416.565} cy={15.244} r={5.616} fill="#6c63ff" />
      <circle cx={435.82} cy={15.244} r={5.616} fill="#6c63ff" />
      <circle cx={455.076} cy={15.244} r={5.616} fill="#6c63ff" />
      <path
        d="M1076.064 439.666H400.519V0h675.545zm-673.94-1.605h672.335V1.605H402.123z"
        fill="#3f3d56"
      />
      <path
        fill="#3f3d56"
        d="M401.321 24.338h673.94v1.605h-673.94zM418.17 19.255a6.418 6.418 0 116.418-6.418 6.426 6.426 0 01-6.418 6.418zm0-11.232a4.814 4.814 0 104.813 4.814 4.82 4.82 0 00-4.813-4.814zM437.425 19.255a6.418 6.418 0 116.419-6.418 6.426 6.426 0 01-6.419 6.418zm0-11.232a4.814 4.814 0 104.814 4.814 4.82 4.82 0 00-4.814-4.814zM456.68 19.255a6.418 6.418 0 116.419-6.418 6.426 6.426 0 01-6.419 6.418zm0-11.232a4.814 4.814 0 104.814 4.814 4.82 4.82 0 00-4.814-4.814z"
      />
      <path fill="#3f3d56" d="M612.109 25.14h1.605v414.346h-1.605z" />
      <path
        fill="#f2f2f2"
        d="M688.733 228.859h117.94v16.046h-117.94zM874.067 228.859h117.94v16.046h-117.94z"
      />
      <path
        d="M813.893 237.684H694.35v-17.65h119.544zm-117.94-1.604H812.29v-14.442H695.954z"
        fill="#3f3d56"
      />
      <path fill="#f2f2f2" d="M688.733 353.217h117.94v16.046h-117.94z" />
      <path
        d="M813.893 362.042H694.35v-17.65h119.544zm-117.94-1.604H812.29v-14.442H695.954z"
        fill="#3f3d56"
      />
      <path fill="#f2f2f2" d="M689.134 289.433h303.273v16.046H689.134z" />
      <path
        d="M999.628 299.863H694.75v-17.65h304.878zm-303.273-1.604h301.668v-14.442H696.355zM999.227 237.684H879.683v-17.65h119.544zm-117.94-1.604h116.335v-14.442H881.287zM509.064 285.458a66 66 0 1166-66 66.075 66.075 0 01-66 66zm0-130a64 64 0 1064 64 64.073 64.073 0 00-64-64zM748.064 744.458h283v2h-283z"
        fill="#3f3d56"
      />
    </svg>
  )
}

const WebDeveloper = styled(Icon)([], space, color, display)

WebDeveloper.displayName = 'WebDeveloper'

WebDeveloper.defaultProps = {
  size: 24,
}

export default WebDeveloper
